import React from "react";
import "./Reverse.css";
import CustomButton from "../../components/CustomButton";
import CustomInput from "../../components/CustomInput";
import CustomLabel from "../../components/CustomLabel";

const Reverse: React.FC = () => {
  const [inputValue, setInputValue] = React.useState("abc");
  const [labelValue, setLabelValue] = React.useState("Any API response will go here");

  const handleClick = () => {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const apiEndPoint = "/test/reverse";
    const apiTextParam = "text=" + inputValue;
    const apiUrl = apiBaseUrl + apiEndPoint + "?" + apiTextParam;

    console.log("Sending [" + apiUrl + "]");

    // Call the API
    fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP API call failed with status: ${response.status}`);
        }
        // Return a promise which might reject if the response is not JSON
        return response.json();
      })
      .then(result => {
        console.log("Successfully parsed JSON: ", result);
        // Process the data
        const reversedText = result?.success?.data?.reversedText;
        setLabelValue(typeof reversedText === "string" ? reversedText : "No result returned from API");
        // Maybe it always returns a default object with a "result" property
      })
      .catch(error => {
        console.error("Error during fetch API call or JSON parsing: ", error);
        // Handle the error eg display message to the user
        alert("An error occurred while calling the API. Please try again. Error details: " + error.message);
      });
  };

  const handleInputChange = (value: string) => setInputValue(value);

  return (
    <div className="reverse-container">
      <CustomInput text={inputValue} onChange={handleInputChange} />
      <CustomLabel text={labelValue} />
      <CustomButton label="Reverse" onClick={handleClick} />
    </div>
  );
};

export default Reverse;